import React, {useState} from 'react'
import {Box, Stack} from '@mui/material'
import UpdateIcon from '@mui/icons-material/Update'
import moment from 'moment'
import ButtonCustom from '@ui/buttons/buttonCustom/ButtonCustom'
import SidebarDatePicker from '@ui/datePicker/mapDatePicker/SidebarDatePicker'
import {useDateStartEndState} from '@ui/datePicker/hooks/useDateStartEndState'
import {DATE_FORMAT_CAMERAS} from '@containers/cameras/constants/dateFormat'
import ActionUiHandler from '@ui/template/actionUiHandler/ActionUiHandler'
import NotItems from '@ui/notItems/NotItems'
import {useGetDeviceRecordingsByPeriodQuery} from '@containers/monitoringPlatform/geoZones/queryHooks/useDeviceRecordingsByPeriodQuery'
import {DeviceRecordingsList} from '@containers/monitoringPlatform/geoZones/recordingsByPeriod/DeviceRecordingsList'

interface IProps {
	accountId: number
	deviceId: number
	singleVoyage?: boolean
}

interface IPeriod {
	dateFrom: string
	dateTo: string
}

export const DeviceRecordingsByPeriod = ({accountId, deviceId, singleVoyage}: IProps) => {
	const dateStartEndContext = useDateStartEndState({
		initialDateStart: moment().startOf('day').format(DATE_FORMAT_CAMERAS),
		initialDateEnd: moment().format(DATE_FORMAT_CAMERAS),
	})

	const [period, setPeriod] = useState<IPeriod | null>(null)

	const {
		data,
		isLoading,
		isFetching,
		refetch,
	} = useGetDeviceRecordingsByPeriodQuery({
		accountId,
		deviceId,
		dateFrom: period?.dateFrom ?? '',
		dateTo: period?.dateTo ?? '',
		enabled: !!period,
		singleVoyage,
	})

	const handleShow = () => {
		setPeriod({
			dateFrom: dateStartEndContext.dateStart,
			dateTo: dateStartEndContext.dateEnd,
		})
	}

	return (
		<Box sx={{p: 1}}>
			<Stack
				direction={{xs: 'column', sm: 'row'}}
				spacing={1}
				alignItems={{xs: 'stretch', sm: 'flex-end'}}
				mb={2}
			>
				<SidebarDatePicker
					dateStartEndContext={dateStartEndContext}
					format={DATE_FORMAT_CAMERAS}
					hasTime
					fullWidth
				/>
				<ButtonCustom
					onClick={handleShow}
					variant="contained"
					disabled={isFetching}
				>
					Показати
				</ButtonCustom>
				{period && (
					<ButtonCustom
						startIcon={<UpdateIcon fontSize="small"/>}
						onClick={() => refetch()}
						variant="outlined"
						disabled={isFetching}
					>
						Оновити
					</ButtonCustom>
				)}
			</Stack>

			{period && (
				<ActionUiHandler
					isLoading={isFetching}
					isLoadingWithoutRender={isLoading}
				>
					{!data?.length && !isLoading && !isFetching && <NotItems/>}
					<DeviceRecordingsList recordings={data || []} accountId={accountId} singleVoyage={singleVoyage}/>
				</ActionUiHandler>
			)}
		</Box>
	)
}

export default DeviceRecordingsByPeriod
